// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"9c555d54","231":"3f75e6e6","291":"32c66e82","453":"6835a9cc","490":"73287a83","508":"61fe2c9b","515":"fa20c2f1","518":"e3f2c3fd","539":"a6e64eae","544":"9f9b749f","582":"f542e617","617":"e6d027eb","801":"5df22f7d"}[chunkId] + ".chunk.js";
};